import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Button from './Button';
import { ArrowLeft, ArrowRight } from '../icons';

const PrimaryButton = (props) => <Button {...props} />;

const SecondaryButton = (props) => <Button inverted {...props} />;

const ContinueButton = (props) => {
  const { t } = useTranslation();
  return (
    <PrimaryButton
      colorScheme="green"
      label={t('buttons.continue')}
      IconRight={ArrowRight}
      {...props}
    />
  );
};

const BackButton = (props) => {
  const { t } = useTranslation();
  return (
    <SecondaryButton
      colorScheme="green"
      label={t('buttons.back')}
      IconLeft={ArrowLeft}
      {...props}
    />
  );
};

const GraphButton = ({ active = false, className = '', ...rest }) => (
  <Button
    className={classNames(
      'graph-button',
      { 'graph-button--inactive': !active },
      className
    )}
    inverted
    {...rest}
  />
);

GraphButton.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string
};

const BorderlessButton = ({ className = '', ...rest }) => (
  <Button 
    className={classNames('borderless-button', className)} 
    inverted 
    {...rest} 
  />
);

BorderlessButton.propTypes = {
  className: PropTypes.string
};

export {
  Button,
  PrimaryButton,
  SecondaryButton,
  ContinueButton,
  BackButton,
  GraphButton,
  BorderlessButton
};
